import { UrlsEnum } from '@lentau/ui-kit/core/enums/route.enum';
import { ScreenName, ScreenTrackingConfig } from './performance-metrics.interfaces';

// Маппинг URL на названия экранов
export const ScreenUrlMap: Array<[string | RegExp, ScreenName]> = [
  // Главная
  [UrlsEnum.Base, ScreenName.HOME],

  // Каталог - поддерживаем формат /catalog/...-56/ или /catalog/123
  [new RegExp(`^${UrlsEnum.Catalog}[^/]+`), ScreenName.CATALOG_LISTING],

  // Карточка товара
  [new RegExp(`^${UrlsEnum.ProductPageLenta}/[a-z0-9-]+/?$`), ScreenName.PRODUCT],

  // Корзина
  [UrlsEnum.BasketPage, ScreenName.CART],

  // Чекаут
  [new RegExp(`^${UrlsEnum.OrderingPage}`), ScreenName.CHECKOUT],

  // Акции
  [new RegExp(`^${UrlsEnum.Action}[^/]+`), ScreenName.ACTION],
];

export enum BlockingRequestsEnum {
  PAGE_WIDGETS = 'api-gateway/v1/pages/widgets/',
  CATALOG_ITEMS = 'catalog/items',
  CATALOG_ITEMS_WITH_SLASH = 'catalog/items/',
  CART_LOOKUP = 'rest/CartLookup',
  ACTION_WIDGETS = 'pages/actions',
}

// Экраны и блокирующие запросы
export const ScreenConfigs: Map<ScreenName | string, ScreenTrackingConfig> = new Map([
  [
    ScreenName.HOME,
    {
      screenName: ScreenName.HOME,
      blockingRequests: [BlockingRequestsEnum.PAGE_WIDGETS],
    },
  ],
  [
    ScreenName.CATALOG_LISTING,
    {
      screenName: ScreenName.CATALOG_LISTING,
      blockingRequests: [BlockingRequestsEnum.CATALOG_ITEMS],
    },
  ],
  [
    ScreenName.PRODUCT,
    {
      screenName: ScreenName.PRODUCT,
      blockingRequests: [BlockingRequestsEnum.CATALOG_ITEMS_WITH_SLASH],
    },
  ],
  [
    ScreenName.CART,
    {
      screenName: ScreenName.CART,
      blockingRequests: [BlockingRequestsEnum.CART_LOOKUP],
    },
  ],
  [
    ScreenName.CHECKOUT,
    {
      screenName: ScreenName.CHECKOUT,
      blockingRequests: [BlockingRequestsEnum.CART_LOOKUP],
    },
  ],
  [
    ScreenName.ACTION,
    {
      screenName: ScreenName.ACTION,
      blockingRequests: [BlockingRequestsEnum.PAGE_WIDGETS],
    },
  ],
]);
